import {
  composeStyles,
  Checkbox as DefaultCheckbox,
  type CheckboxProps as DefaultCheckboxProps,
} from '@vgn-medien-holding/vgn-fe-components';
import checkboxStyle from './styles/default';

export const Checkbox = ({ id, label, checkboxProps, classProps }: DefaultCheckboxProps) => {
  const styles = composeStyles(checkboxStyle, classProps);
  return <DefaultCheckbox id={id} label={label} classProps={styles} checkboxProps={checkboxProps} />;
};
